// extracted by mini-css-extract-plugin
export default {"overAll":"carousel_overAll__JxBol","leftArrow":"carousel_leftArrow__7rZUM","scroll":"carousel_scroll__GjbHI","rightArrow":"carousel_rightArrow__5nKDW"};